import { memoizeDeep } from "../common/utilities";
const setTheme = memoizeDeep(function (_ref) {
  let {
    balloonbutton
  } = _ref;
  let cssBalloonRoot = {},
      cssBalloonArrow = {},
      cssBalloonCloseBtn = {},
      cssBalloonDialog = {},
      cssBalloonContent = {},
      cssBalloonHeader = {},
      cssBalloonBody = {},
      cssBalloonFooter = {},
      cssBalloonIcon = {};

  if (balloonbutton) {
    cssBalloonRoot = balloonbutton.root;
    cssBalloonArrow = balloonbutton.arrow;
    cssBalloonCloseBtn = balloonbutton.balloonCloseButton;
    cssBalloonDialog = balloonbutton.balloonDialog;
    cssBalloonContent = balloonbutton.balloonContent;
    cssBalloonHeader = balloonbutton.balloonHeader;
    cssBalloonBody = balloonbutton.balloonBody;
    cssBalloonFooter = balloonbutton.balloonFooter;
    cssBalloonIcon = balloonbutton.balloonIcon;
  }

  return {
    cssBalloonRoot,
    cssBalloonArrow,
    cssBalloonCloseBtn,
    cssBalloonDialog,
    cssBalloonContent,
    cssBalloonBody,
    cssBalloonHeader,
    cssBalloonFooter,
    cssBalloonIcon
  };
});
export default function (_ref2) {
  var _theme$components;

  let {
    theme
  } = _ref2;
  const balloonbutton = theme === null || theme === void 0 ? void 0 : (_theme$components = theme.components) === null || _theme$components === void 0 ? void 0 : _theme$components.balloonbutton;
  return setTheme({
    balloonbutton
  });
}